import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=03e6117a&scoped=true&"
import script from "./Waiting.vue?vue&type=script&lang=js&"
export * from "./Waiting.vue?vue&type=script&lang=js&"
import style0 from "./Waiting.vue?vue&type=style&index=0&id=03e6117a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e6117a",
  null
  
)

export default component.exports